import React, { useEffect, useContext } from 'react'
import useData from '../hooks/useData'
import Loading from './Loading'
import { ResourcesContext } from './ArticleResourcesContent'

const InspectUrl = props => {
    const resourcesContext = useContext(ResourcesContext)
    const url = props.url
    const CrawledPage = useData(
        {
            url: 'competitor/crawl_page?url64=' + btoa(url)
        },
        [props.url]
    )
    const CrawledPageDetails = useData(
        {
            url: 'competitor/extract_from_page?url64=' + btoa(url)
        },
        [props.url]
    )

    const { origin, target_article, originalUrl, displayUrl } = props
    const { article_id } = resourcesContext

    useEffect(resourcesContext.addUIToText({ origin, target_article: !!article_id, originalUrl, displayUrl }), [CrawledPage.data])
    useEffect(() => props.useEffect && props.useEffect(), [props.useEffect, CrawledPage.data])
    return (
        <>
            {(CrawledPage.isReady && (
                <>
                    <div className='row'>
                        <div className='col-xxl-12'>
                            <ul className='list-unstyled'>
                                <li>
                                    <small>
                                        {(CrawledPageDetails.isReady && (
                                            <>
                                                {CrawledPageDetails.isReady && CrawledPageDetails.data.affiliate_links && CrawledPageDetails.data.affiliate_links.length} affiliate link
                                                {(CrawledPageDetails.isReady && CrawledPageDetails.data.affiliate_links && CrawledPageDetails.data.affiliate_links != 1 && 's') || null}
                                            </>
                                        )) || <span className='text-muted'>Loading affiliate links...</span>}
                                    </small>
                                </li>
                                <li>
                                    <small>
                                        {(CrawledPageDetails.isReady && (
                                            <>
                                                {CrawledPageDetails.isReady && CrawledPageDetails.data.internal_links && CrawledPageDetails.data.internal_links.length} internal link
                                                {(CrawledPageDetails.isReady && CrawledPageDetails.data.affiliate_links && CrawledPageDetails.data.internal_links != 1 && 's') || null}
                                            </>
                                        )) || <span className='text-muted'>Loading internal links...</span>}
                                    </small>
                                </li>
                                <li>
                                    <small>
                                        {(CrawledPageDetails.isReady && (
                                            <>
                                                {CrawledPageDetails.isReady && CrawledPageDetails.data.external_links && CrawledPageDetails.data.external_links.length} external link
                                                {(CrawledPageDetails.isReady && CrawledPageDetails.data.affiliate_links && CrawledPageDetails.data.external_links != 1 && 's') || null}
                                            </>
                                        )) || <span className='text-muted'>Loading external links...</span>}
                                    </small>
                                </li>
                            </ul>
                            <div className='competitor-page-html' dangerouslySetInnerHTML={{ __html: CrawledPage.data.body }} />
                        </div>
                    </div>
                </>
            )) || <Loading text='Fetching data for Url' />}
        </>
    )
}

export default InspectUrl
